/**
 * @generated SignedSource<<39f18a245a31c007c77ce5f5c9ee8f94>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceStarWriteStarredSpacesFragment$data = {
  readonly nodes: ReadonlyArray<{
    readonly alias: string | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null> | null;
  readonly " $fragmentType": "SpaceStarWriteStarredSpacesFragment";
};
export type SpaceStarWriteStarredSpacesFragment$key = {
  readonly " $data"?: SpaceStarWriteStarredSpacesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceStarWriteStarredSpacesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceStarWriteStarredSpacesFragment",
  "selections": [
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "alias"
        },
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "path"
            }
          ]
        }
      ]
    }
  ],
  "type": "PaginatedSpaceList"
};

(node as any).hash = "72f0ab1980fee3d3ebcdbd9647ddc161";

export default node;
